// "Recently released" helper — shared by the library card's "New" badge and the new-content
// alert so both agree on what counts as new. A module is recent when it has gone live
// (begins_at has passed) within the trailing window.

import type { ModuleSummary } from '../types';

/** How long a newly gone-live module reads as "New". Matches the new-content alert lifespan. */
export const RECENT_MODULE_WINDOW_MS = 14 * 24 * 60 * 60 * 1000; // 14 days

/** True when the module went live (begins_at <= now) within RECENT_MODULE_WINDOW_MS. */
export function isRecentlyReleased(module: Pick<ModuleSummary, 'begins_at'>, now: Date): boolean {
  const began = new Date(module.begins_at).getTime();
  if (Number.isNaN(began)) return false;
  const nowMs = now.getTime();
  return began <= nowMs && nowMs - began <= RECENT_MODULE_WINDOW_MS;
}
